<template>
    <div class="price-container standard">
        <div class="price-value" v-if="info.listingStatus == 'Sold'">
            <p class="price_all">
                <no-disclosure
                    v-if="!!info.nodisclosureDes || hidePrice"
                    :des="
                        hidePrice
                            ? $t('md-detail-info.nondisclosure')
                            : info.nodisclosureDes
                    "
                />
                <span v-else class="sold-price">
                    {{
                        $ft.formatCurrency({
                            value: houseShowSoldPrice ? info.soldPrice : info.price,
                            currencySymbol
                        })
                    }}
                    <TaxStatus :info="info" />
                </span>
            </p>
            <p
                v-if="
                    showListingPrice &&
                        houseShowSoldPrice &&
                        info.nodisclosureDes == null
                "
                class="trend-price"
            >
                <span class="initial-price">{{
                    $ft.formatCurrency({ value: info.price, currencySymbol })
                }}<TaxStatus :info="info" /></span>
                <span
                    v-if="
                        info.price &&
                            info.soldPrice != info.price &&
                            trend !== '0.0%'
                    "
                    class="house-trend"
                    :class="{
                        up: info.soldPrice > info.price,
                        down: info.soldPrice < info.price
                    }"
                >
                    <span class="iconfont icon-trend-up"></span>
                    <span class="iconfont icon-trend-down"></span>
                    {{ trend }}
                </span>
            </p>
        </div>
        <div class="origin-price" v-else>
            <no-disclosure
                v-if="!!info.nodisclosureDes || hidePrice"
                :des="
                    hidePrice
                        ? $t('md-detail-info.nondisclosure')
                        : info.nodisclosureDes
                "
            />
            <span class="price-number" v-else>
                {{ $ft.formatCurrency({ value: info.price, currencySymbol}) }}<TaxStatus :info="info" />
            </span>
        </div>
    </div>
</template>

<script>
import price from "../../price.js"
export default {
    mixins: [price]
};
</script>

<style lang="scss">
@import '../../../../theme/mixin.scss';
@import '../../../../theme/media.scss';
.price-container.standard {
    .nodisclosure {
        display: inline-flex;
        .dollar {
            @include color-theme();
        }
        .secret {
            @include color-theme();
        }
    }
    .price-value {
        display: inline-block;
        .price_all {
            display: flex;
            .sold-price {
                display: inline-block;
                color: var(--color-holder);
                font-size: 30px;
                line-height: 30px;
                font-family: var(--font-medium);
            }
            .caculator {
                margin-left: 40px;
                font-size: 14px;
                display: inline-block;
            }
        }
        .trend-price {
            margin-top: 10px;
            .initial-price {
                color: var(--color-holder);
                font-size: 14px;
                text-decoration: line-through;
            }
            .house-trend {
                margin-left: 10px;
                font-size: 14px;
                font-family: var(--font-bold);
                display: inline-flex;
                align-items: center;
                &:before {
                    margin-right: 4px;
                    font-size: 14px;
                }
                .icon-trend-up,
                .icon-trend-down {
                    display: none;
                    font-size: 12px;
                    margin-right: 4px;
                }
                &.up {
                    color: #96efb4;
                    .icon-trend-up {
                        display: inline;
                    }
                }
                &.down {
                    color: #ff0000;
                    .icon-trend-down {
                        display: inline;
                    }
                }
            }
        }
    }
    .origin-price {
        font-size: 30px;
        color: var(--color-text);
        font-family: var(--font-bold);
        line-height: 30px;
    }
}
@media (max-width: 600px) {
    .price-container.standard {
        margin-top: 10px;
        .nodisclosure {
            .dollar {
                font-size: 20px;
            }
            .secret {
                font-size: 12px;
            }
            .des {
                font-size: 12px;
            }
        }
        .price-value {
            .price_all {
                .sold-price {
                    font-size: 28px;
                }
                .caculator {
                    display: none;
                }
            }
            .trend-price {
                .initial-price {
                    font-size: 12px;
                }
                .house-trend {
                    font-size: 12px;
                }
            }
        }
        .origin-price {
            display: block;
            .price-number {
                font-size: 28px;
                font-family: var(--font-bold);
                color: var(--color-text);
            }
        }
    }
}
</style>
